import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c39f20f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-h5 ringbearer" }, "Estadísticas", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-h5 ringbearer" }, " Partidas pendientes de validar ", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-h5 ringbearer" }, "Partidas validadas", -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No tienes partidas validadas", -1))
const _hoisted_10 = [
  _hoisted_9
]

import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import CardTitleMisPartidas from "@/components/PartidaAmistosa/CardTitleMisPartidas.vue";
import PendingMatchCard from "@/components/PartidaAmistosa/PendingMatchCard.vue";
import ValidadasMatchCard from "@/components/PartidaAmistosa/ValidadasMatchCard.vue";
import CardEstadisticas from "@/components/Perfil/CardEstadisticas.vue";
import { useAuth } from "@/composables/useAuth";
import { FaccionDTO } from "@/interfaces/Faccion";
import { ViewPartidaAmistosaDTO } from "@/interfaces/Partidas";
import { UsuarioDataDTO } from "@/interfaces/Usuario";
import { getFaccionByIdUser } from "@/services/FaccionesService";
import { getPartidasAmistosasByIdUser } from "@/services/PartidasAmistosasService";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { getProteccionDatos } from "@/services/UsuariosService";
import ModalProteccionDatos from "@/components/Usuarios/ModalProteccionDatos.vue";
import ModalRegistrarPartida from "@/components/PartidaAmistosa/ModalRegistrarPartida.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MisPartidasView',
  setup(__props) {

const isLoading = ref(true);
const { getidUsuario } = useAuth();
const router = useRouter();
const idUsuarioLogger = ref<number>(parseInt(getidUsuario.value));
const matches = ref<ViewPartidaAmistosaDTO[]>([]);
const pendingMatches = ref<ViewPartidaAmistosaDTO[]>([]);
const validMatches = ref<ViewPartidaAmistosaDTO[]>([]);
const isLoadingPending = ref<boolean>(false);
const isLoadingValidadas = ref<boolean>(false);
const faccionDTO = ref<FaccionDTO>({
  idFaccion: 0,
  nombreFaccion: "",
});
const openRegistroPartida = () => {
  dialog.value = true;
};
const usuarioData = ref<UsuarioDataDTO>({
  idUsuario: 0,
  nick: "",
  email: "",
  faccion: faccionDTO.value,
  partidasValidadas: [],
  partidasPendientes: [],
  elos: [],
  InscripcionesIndividualTorneo: [],
  InscripcionesEquipoTorneo: [],
  clasificacionElo: 0,
  puntuacionElo: 0,
  numeroPartidasJugadas: 0,
  partidasGanadas: 0,
  partidasEmpatadas: 0,
  partidasPerdidas: 0,
  proteccionDatos: null,
  PartidasTorneo: [],
  ClasificacionTorneos: [],
  rankingElo: 0,
});
const dialog = ref<boolean>(false);
const showModalProteccionDatos = ref<boolean>(false);

//Variables para filtrar partidas segun el click en la barra de estadisticas
const filtroActivo = ref<"win" | "loss" | "draw" | null>(null);

const partidasFiltradas = computed(() => {
  if (!filtroActivo.value) return matches.value;

  return matches.value.filter((partida) => {
    const esVictoria = partida.ganadorPartida === idUsuarioLogger.value;
    const esEmpate =
      partida.ganadorPartida === null || partida.ganadorPartida === 0;
    const esDerrota =
      partida.ganadorPartida &&
      partida.ganadorPartida !== idUsuarioLogger.value;

    return (
      (filtroActivo.value === "win" && esVictoria) ||
      (filtroActivo.value === "draw" && esEmpate) ||
      (filtroActivo.value === "loss" && esDerrota)
    );
  });
});

const initializeComponent = async () => {
  if (idUsuarioLogger.value) {
    isLoading.value = true;
    isLoadingPending.value = true;
    isLoadingValidadas.value = true;
    try {
      const response = await getPartidasAmistosasByIdUser(
        idUsuarioLogger.value
      );
      matches.value = response.data;
      matches.value.forEach((element) => {
        if (element.partidaValidadaUsuario1 && element.partidaValidadaUsuario2)
          validMatches.value.push(element);
        else pendingMatches.value.push(element);
      });

      validMatches.value = validMatches.value.reverse();
      pendingMatches.value = pendingMatches.value.reverse();

      loadComunidad(idUsuarioLogger.value);
      loadResume(validMatches.value);
    } catch (error) {
      console.error(error);
      router.push({ name: "error" });
    } finally {
      isLoading.value = false;
      isLoadingPending.value = false;
      isLoadingValidadas.value = false;

      const response = await getProteccionDatos(idUsuarioLogger.value);

      if (!response.data) showModalProteccionDatos.value = true;
    }
  }
};

const cerrarModal = () => {
  showModalProteccionDatos.value = false;
};

const loadResume = async (matches: ViewPartidaAmistosaDTO[]) => {
  usuarioData.value.numeroPartidasJugadas = matches.length;

  let contadorGanadas = 0;
  let contadorEmpatadas = 0;
  let contadorPerdidas = 0;

  matches.forEach((element) => {
    const ganador = element.ganadorPartida;

    if (ganador === idUsuarioLogger.value) {
      contadorGanadas++;
    } else if (!ganador) {
      // Si es null, 0 o undefined, lo tomamos como empate
      contadorEmpatadas++;
    } else {
      contadorPerdidas++;
    }
  });

  usuarioData.value.partidasGanadas = contadorGanadas;
  usuarioData.value.partidasEmpatadas = contadorEmpatadas;
  usuarioData.value.partidasPerdidas = contadorPerdidas;
};

onMounted(initializeComponent);

const loadComunidad = async (idUser: number) => {
  try {
    const response = await getFaccionByIdUser(idUser);
    usuarioData.value.faccion.nombreFaccion = response.data;
  } catch (error) {
    console.error("Error al obtener las comunidades: ", error);
  }
};

const refrescarPartidas = async () => {
  pendingMatches.value = [];
  if (idUsuarioLogger.value) {
    // Aquí llamas a la API para obtener las partidas actualizadas
    try {
      const response = await getPartidasAmistosasByIdUser(
        idUsuarioLogger.value
      );
      matches.value = response.data;
      matches.value.forEach((element) => {
        if (element.partidaValidadaUsuario1 && element.partidaValidadaUsuario2)
          validMatches.value.push(element);
        else pendingMatches.value.push(element);
      });

      validMatches.value = validMatches.value.reverse();
      pendingMatches.value = pendingMatches.value.reverse();
    } catch (error) {
      console.error(error);
      router.push({ name: "error" });
    } finally {
      isLoadingPending.value = false;
    }
  }
};

function filtrarPartidas(tipo: "win" | "loss" | "draw" | null) {
  filtroActivo.value = tipo;
}

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, { class: "text-center" }, {
      default: _withCtx(() => [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(LoadingGandalf)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(CardTitleMisPartidas, {
                message: "Mis Partidas",
                textsize: "text-h4"
              }),
              _createVNode(_component_v_spacer, { class: "my-4" }),
              _createVNode(_component_v_btn, {
                onClick: openRegistroPartida,
                variant: "tonal",
                class: "animated-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Registrar nueva Partida ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer, { class: "my-4" }),
              _createVNode(_component_v_card, { class: "section-card stats-section pt-0 mt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "12",
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CardEstadisticas, {
                        usuario: usuarioData.value,
                        onFiltroCambiar: filtrarPartidas
                      }, null, 8, ["usuario"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (pendingMatches.value.length > 0 && !isLoadingPending.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_v_card, { class: "section-card stats-section pt-0 mt-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_divider),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingMatches.value, (match) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            cols: "12",
                            sm: "8",
                            "offset-sm": "2",
                            md: "6",
                            "offset-md": "3",
                            key: match.idPartidaAmistosa
                          }, {
                            default: _withCtx(() => [
                              _createVNode(PendingMatchCard, {
                                match: match,
                                class: "mb-4",
                                onRegistroExitoso: refrescarPartidas
                              }, null, 8, ["match"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (!isLoadingValidadas.value && validMatches.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_v_card, { class: "section-card stats-section pt-0 mt-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_divider),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partidasFiltradas.value, (match) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                cols: "12",
                                sm: "6",
                                md: "6",
                                lg: "4",
                                xl: "4",
                                class: "pb-0",
                                key: match.idPartidaAmistosa
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(ValidadasMatchCard, {
                                    idUsuario: idUsuarioLogger.value,
                                    match: match,
                                    class: "mb-4"
                                  }, null, 8, ["idUsuario", "match"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)),
              _createVNode(_component_v_divider, { class: "my-3" })
            ])),
        _createVNode(_component_v_dialog, {
          modelValue: dialog.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(ModalRegistrarPartida, {
              onClose: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false)),
              onRegistroExitoso: refrescarPartidas
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (showModalProteccionDatos.value)
      ? (_openBlock(), _createBlock(ModalProteccionDatos, {
          key: 0,
          onModalClosed: cerrarModal
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})